import { RichText } from "@/components/ui/RichText";
import { TextHeroStoryblok } from "@/generated/sb/sb-types";
import { BlokProps, StoryblokComponent } from "@frend-digital/storyblok";
import styles from "./index.module.css";

export const TextHeroBlok = ({
  blok,
  preview,
  restProps,
}: BlokProps<TextHeroStoryblok> & {
  restProps?: {
    pageOrder?: number;
  };
}) => {
  const { title, text, link } = blok;
  return (
    <article className={styles.textHero}>
      <div className={styles.text}>
        <h2 className={styles.title}>{title}</h2>
        <RichText>{text}</RichText>
      </div>
      {link?.[0] && (
        <StoryblokComponent
          blok={link?.[0]}
          restProps={restProps?.pageOrder}
          preview={preview}
        />
      )}
    </article>
  );
};
